import React, { useState, useEffect, useRef } from "react";
import {
  Text,
  StyleSheet,
  View,
  ScrollView,
  LayoutAnimation,
  TouchableOpacity,
  Animated,
  Easing,
  Dimensions,
  Image,
  Platform,
} from "react-native";

//import HtmlComponent from "../../common/HtmlComponent";
import AppConfig from "../../../../../config/AppConfig";
import ChromeIcon from "../../../common/icons/ChromeIcon";
import { resolveIconURI } from "../../../../../helpers/utils";
import Collapsible from "../../../common/Collapsible/Collapsible";
import Icons from "../../../common/icons/index";
import ImageComponent from "../../../common/ImageComponent";
import AppTheme from "../../../AppTheme";

const { height: HEIGHT } = Dimensions.get("window");

export default function IntegrationData({
  sourceId,
  updateSelectedPrediction,
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [color, setColor] = useState(new Animated.Value(0));

  useEffect(() => {
    if (sourceId > 0) {
      setSelectedId(sourceId);
      scrollToItem();
    }
  }, [sourceId]);

  const scrollToItem = () => {
    Animated.sequence([
      Animated.timing(color, {
        toValue: 1,
        duration: 500,
        easing: Easing.ease,
        useNativeDriver: true,
      }),
      Animated.delay(800),
      Animated.timing(color, {
        toValue: 0,
        duration: 500,
        easing: Easing.ease,
        useNativeDriver: true,
      }),
    ]).start(() => {
      // When multiple predictions with the same source we reset the selection
      updateSelectedPrediction(0);
    });
  };

  const toggleExpand = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setIsCollapsed(!isCollapsed);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={toggleExpand}>
        <Text style={styles.header}>All Integration Data</Text>
      </TouchableOpacity>

      <Collapsible isCollapsed={isCollapsed}>
        <ScrollView
          style={styles.listContainer}
          ref={(ref) => {
            scrollview_ref = ref;
          }}
        >
          <Animated.View
            style={[
              styles.listItem,
              selectedId == 1 && {
                backgroundColor: color.interpolate({
                  inputRange: [0, 1],
                  outputRange: ["#FFF", AppTheme.DEFAULT_COLOR],
                }),
              },
            ]}
          >
            <Icons.GCalendarIcon styles={styles.icon} />
            <TouchableOpacity>
              <Text style={styles.dataHeader}>Product weekly</Text>
              <Text style={styles.data}>8:30 - 9:00</Text>
              <Text style={styles.dataHeader}>Customers weekly</Text>
              <Text style={styles.data}>9:00 - 9:30</Text>
              <Text style={styles.dataHeader}>Birthday Breakfast Social</Text>
              <Text style={styles.data}>10:00 - 11:00</Text>
            </TouchableOpacity>
          </Animated.View>
          <Animated.View
            style={[
              styles.listItem,
              selectedId == 2 && {
                backgroundColor: color.interpolate({
                  inputRange: [0, 1],
                  outputRange: ["#FFF", AppTheme.DEFAULT_COLOR],
                }),
              },
            ]}
          >
            <ImageComponent
              styles={styles.icon}
              image={resolveIconURI(ChromeIcon)}
            />
            <TouchableOpacity>
              <Text style={styles.dataHeader}>Product weekly</Text>
              <Text style={styles.data}>8:30 - 9:00</Text>
              <Text style={styles.dataHeader}>Customers weekly</Text>
              <Text style={styles.data}>9:00 - 9:30</Text>
              <Text style={styles.dataHeader}>Birthday Breakfast Social</Text>
              <Text style={styles.data}>10:00 - 11:00</Text>
            </TouchableOpacity>
          </Animated.View>

          {/*  {integrationData.map((data, index) => (
            <View key={index} style={styles.listItem}>
              {data.icon && <data.icon styles={styles.icon} />}

              <HtmlComponent styles={styles.webView} html={data.content} />
            </View>
          ))} */}
        </ScrollView>
      </Collapsible>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    borderRadius: 4,
    paddingBottom: 80,
    marginTop: 10,
  },
  header: {
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-SemiBold" }),
    fontWeight: "bold",
    fontSize: 20,
    lineHeight: 30,
    paddingLeft: 14,
    paddingTop: 10,
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    color: "#333",
  },
  listContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
    display: "flex",
    margin: "auto",
    borderWidth: 0,
    paddingHorizontal: 15,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    paddingVertical: 5,
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 20,
    marginTop: 5,
  },
  webView: {
    height: 100,
    width: 100,
  },
  dataHeader: {
    fontSize: 12,
    fontWeight: "500",
  },
  data: {
    fontWeight: "200",
    fontSize: 12,
    color: "#555",
  },
});
